import React, {useContext} from "react";
import {LanguageContext} from "../../../context/LanguageContext";
import Grid from "@mui/material/Grid";
import {Paper} from "@mui/material";
import Typography from "@mui/material/Typography";
import {CompanyEnvironmentContext} from "../../../context/CompanyEnvironmentContext";
import CompanyDataGrid from "../../common/CompanyDataGrid";
import Rendered from "../../Rendered";

const CompanyData = () => {
  const languageContext = useContext(LanguageContext);
  const companyEnvironmentContext = useContext(CompanyEnvironmentContext);

  const companyDataList = [
    {title: "headquarters", value: companyEnvironmentContext.corporate.headquarters},
    {title: "registrationNumber", value: companyEnvironmentContext.corporate.registrationNumber},
    {title: "registeringCourt", value: companyEnvironmentContext.corporate.registeringCourt},
    {title: "taxNumber", value: companyEnvironmentContext.corporate.taxNumber},
    {title: languageContext.dictionary.bankAccount + " (HUF)", value: companyEnvironmentContext.corporate.bankAccountHUF},
    {title: languageContext.dictionary.bankAccount + " (EUR)", value: companyEnvironmentContext.corporate.bankAccountEUR},
    {title: languageContext.dictionary.bankAccount + " (USD)", value: companyEnvironmentContext.corporate.bankAccountUSD},
  ];

  return (
    <Grid container marginTop={5} seleniumid="InvitechCompanyDataGrid">
      <Grid item marginBottom={1}>
        <Typography variant="h4">{languageContext.dictionary.companyNameOfficial}</Typography>
      </Grid>
      <Grid container item direction="row" justifyContent="center" alignItems="center">
        <Paper elevation={4} sx={{width: "100%", paddingTop: 3, paddingBottom: 3, paddingLeft: 1, paddingRight: 1}}>
          {companyDataList.map((companyData, index) => (
            <Rendered rendered={!!companyData.value} key={`companyDataGrid_${index}`}>
              <CompanyDataGrid title={companyData.title} value={companyData.value}/>
            </Rendered>
          ))}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default CompanyData;
